module.exports = __webpack_public_path__ + "img/title-2.73d842e1.png";